export const fmtMoney = (v) => {
  if (v == null || v === "") return "—";
  return "€" + Number(v).toLocaleString("en-IE", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IE", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const fmtDateShort = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IE", { day: "2-digit", month: "short" });
  } catch {
    return d;
  }
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IE", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return d;
  }
};

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export const todayISO = () => new Date().toISOString().slice(0, 10);
